import React from 'react';
import { Badge } from './ui/badge';

const configs = {
  1: { label: '1ª vez', cls: 'bg-green-500/10 text-green-600 border-green-500/20' },
  2: { label: '2ª vez', cls: 'bg-amber-500/10 text-amber-600 border-amber-500/20' },
};

export default function CourseCountBadge({ count }) {
  if (!count) return <span className="text-[#2B4B8C]/30">-</span>;
  const c = configs[count] || { label: `${count}ª vez`, cls: 'bg-red-500/10 text-red-500 border-red-500/20' };
  return (
    <Badge className={`${c.cls} border text-xs font-semibold`} data-testid={`course-count-${count}`}>
      {c.label}
    </Badge>
  );
}
